import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { getGlobalStyleSheets } from '../../global-styles';

import * as SidePanelTags from './side-panel.tagnames';

@customElement(SidePanelTags.SidePanelHeaderStatus)
export class AtlSidePanelHeaderStatus extends LitElement {
   static styles = [
      ...getGlobalStyleSheets(),
      css`
         :host {
            display: block;
         }

         .side-panel-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
         }
         ::slotted([slot='header-status']) {
            font-size: 0.75rem;
         }
      `,
   ];

   render() {
      return html`
         <div class="side-panel-header">
            <slot name="header-title"></slot>
            <div class="side-panel-header-status-container">
               <slot name="header-status"></slot>
            </div>
         </div>
      `;
   }
}
